import React, {Component} from 'react';
import {withTranslation} from "react-i18next";

class WhatsAppWidget extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <a target="_blank" href={window.questiaSpecificWebsiteConfig.WHATSAPP_PAGE_URL} className="box bg--white text-center">
                        <span
                            className="box__title color--black pv-sm">{this.props.t('sidebarRight.widget_whatsapp.text1_1',"Join us on")}&nbsp;<strong>{this.props.t('sidebarRight.widget_whatsapp.text1_2',"<K2T> questia.this.props.t('sidebarRight.widget_whatsapp.text1_2 </K2T>")}</strong>{this.props.t('sidebarRight.widget_whatsapp.text1_3',"!")}</span>
                <img className="box__image" style={{padding: "30px"}} src={"specific/images/whatsapp_box.png"} alt=""/>
                <img className="box__image mv-sm" src={"specific/images/whatsapp_man_floor.png"} alt=""/>
            </a>
        );
    }
}

export default withTranslation()(WhatsAppWidget);